<template>
  <Suspense
    @pending="() => onLoadPending()"
    @resolve="() => onLoadResolve()">
    <template #default>
      <ClosetDetailFlyout v-if="flyoutName === 'closet-detail'"/>
      <MyCaseFlyout v-else-if="flyoutName === 'my-case'"/>
      <ReplacementFlyout v-else-if="flyoutName === 'replacement'"/>
      <StyleColorSetFiltersFlyout v-else-if="flyoutName === 'style-color-set-filters'"/>
    </template>
  </Suspense>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { useOverlaysStore } from '@/stores/overlays.js'
import useRouteLoading from '@shared/composables/routeLoading.js'

const ClosetDetailFlyout = defineAsyncComponent(() => import('../closet/ClosetDetailFlyout.vue'))
const MyCaseFlyout = defineAsyncComponent(() => import('../case/MyCaseFlyout.vue'))
const ReplacementFlyout = defineAsyncComponent(() => import('../account/replacements/ReplacementFlyout.vue'))
const StyleColorSetFiltersFlyout = defineAsyncComponent(() => import('@/components/styleColorSet/filtersFlyout/StyleColorSetFiltersFlyout.vue'))

const { flyoutName } = storeToRefs(useOverlaysStore())
const { onLoadPending, onLoadResolve } = useRouteLoading()
</script>
